<template>
  <i :class="iconClass" :style="iconStyle"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    spin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      // Mapeamento completo MDI → FontAwesome
      const iconMap = {
        // Ações
        'mdi-plus-circle': 'fas fa-plus-circle',
        'mdi-plus': 'fas fa-plus',
        'mdi-delete': 'fas fa-trash',
        'mdi-trash-can-outline': 'far fa-trash-alt',
        'mdi-folder-open-outline': 'far fa-folder-open',
        'mdi-pencil': 'fas fa-pencil',
        'mdi-pencil-outline': 'far fa-edit',
        'mdi-close': 'fas fa-times',
        'mdi-close-circle': 'fas fa-times-circle',
        'mdi-cancel': 'fas fa-times-circle',
        'mdi-check-circle': 'fas fa-check-circle',
        'mdi-check': 'fas fa-check',
        'mdi-check-circle-outline': 'far fa-check-circle',
        'mdi-alert-circle': 'fas fa-exclamation-circle',
        'mdi-alert-circle-outline': 'far fa-exclamation-circle',
        'mdi-alert': 'fas fa-exclamation-triangle',
        'mdi-information-outline': 'fas fa-info-circle',
        'mdi-minus-circle': 'fas fa-minus-circle',
        
        // Navegação
        'mdi-chevron-left': 'fas fa-chevron-left',
        'mdi-chevron-right': 'fas fa-chevron-right',
        'mdi-chevron-down': 'fas fa-chevron-down',
        'mdi-chevron-double-down': 'fas fa-angle-double-down',
        'mdi-menu': 'fas fa-bars',
        'mdi-menu-open': 'fas fa-times',
        'mdi-home': 'fas fa-home',
        'mdi-view-dashboard': 'fas fa-tachometer-alt',
        
        // Sistema
        'mdi-loading': 'fas fa-spinner',
        'mdi-magnify': 'fas fa-search',
        'mdi-account': 'fas fa-user',
        'mdi-cog-outline': 'far fa-cog',
        'mdi-lock': 'fas fa-lock',
        'mdi-lock-check': 'fas fa-lock',
        'mdi-email': 'fas fa-envelope',
        'mdi-phone': 'fas fa-phone',
        'mdi-google': 'fab fa-google',
        
        // Financeiro
        'mdi-wallet-outline': 'fas fa-wallet',
        'mdi-cash-multiple': 'fas fa-money-bill-wave',
        'mdi-chart-line': 'fas fa-chart-line',
        'mdi-trophy': 'fas fa-trophy',
        'mdi-pot-mix': 'fas fa-blender',
        'mdi-currency-usd': 'fas fa-dollar-sign',
        
        // Estados
        'mdi-play-circle': 'fas fa-play-circle',
        'mdi-play': 'fas fa-play',
        'mdi-pause-circle': 'fas fa-pause-circle',
        'mdi-pause': 'fas fa-pause',
        'mdi-stop-circle': 'fas fa-stop-circle',
        
        // Account specific icons
        'mdi-briefcase-check': 'fas fa-briefcase',
        'mdi-download': 'fas fa-download',
        'mdi-shield-check': 'fas fa-shield-alt',
        'mdi-chart-donut': 'fas fa-chart-pie',
        'mdi-soccer': 'fas fa-futbol',
        'mdi-soccer-field': 'fas fa-map',
        'mdi-access-point': 'fas fa-wifi',
        'mdi-shield-crown': 'fas fa-crown',
        'mdi-logout': 'fas fa-sign-out-alt',
        'mdi-clock-outline': 'far fa-clock',
        'mdi-target': 'fas fa-bullseye',
        'mdi-calendar-check': 'fas fa-calendar-check',
        'mdi-lightbulb-on': 'fas fa-lightbulb',
        'mdi-star': 'fas fa-star',
        'mdi-thumb-up': 'fas fa-thumbs-up',
        'mdi-thumb-down': 'fas fa-thumbs-down',
        'mdi-minus': 'fas fa-minus',
        'mdi-information': 'fas fa-info-circle',
        'mdi-clock-alert': 'fas fa-clock',
        
        // Pots and dashboard
        'mdi-calendar-clock': 'fas fa-calendar-alt',
        'mdi-cash-plus': 'fas fa-plus-circle',
        'mdi-cash': 'fas fa-money-bill',
        'mdi-cash-minus': 'fas fa-minus-circle',
        'mdi-account-group': 'fas fa-users',
        'mdi-account-multiple': 'fas fa-users',
        'mdi-account-question': 'fas fa-user-question',
        'mdi-account-search': 'fas fa-user-search',
        'mdi-trophy-outline': 'far fa-trophy',
        'mdi-trophy-variant': 'fas fa-medal',
        'mdi-history': 'fas fa-history',
        'mdi-crown': 'fas fa-crown',
        'mdi-medal': 'fas fa-medal',
        
        // Charts and analytics
        'mdi-chart-timeline-variant': 'fas fa-chart-area',
        'mdi-chart-box-outline': 'far fa-chart-bar',
        'mdi-chart-bar-stacked': 'fas fa-chart-bar',
        'mdi-trending-down': 'fas fa-arrow-trend-down',
        'mdi-trending-up': 'fas fa-arrow-trend-up',
        'mdi-arrow-up-bold': 'fas fa-arrow-up',
        'mdi-arrow-down-bold': 'fas fa-arrow-down',
        'mdi-arrow-up': 'fas fa-arrow-up',
        'mdi-arrow-down': 'fas fa-arrow-down',
        'mdi-arrow-right': 'fas fa-arrow-right',
        'mdi-brain': 'fas fa-brain',
        
        // Financial icons
        'mdi-wallet': 'fas fa-wallet',
        'mdi-bank': 'fas fa-university',
        'mdi-percent': 'fas fa-percent',
        'mdi-eye': 'fas fa-eye',
        'mdi-message': 'fas fa-comment',
        'mdi-refresh': 'fas fa-sync-alt',
        'mdi-plus-circle-outline': 'far fa-plus-circle',
        'mdi-check-decagram': 'fas fa-certificate',
        'mdi-robot': 'fas fa-robot',
        'mdi-monitor-dashboard': 'fas fa-desktop',
        'mdi-timeline-clock': 'fas fa-stream',
        'mdi-cellphone-message': 'fas fa-mobile-alt',
        'mdi-face-recognition': 'fas fa-id-card',
        'mdi-key-variant': 'fas fa-key',
        
        // Account types
        'mdi-domain': 'fas fa-building',
        'mdi-piggy-bank': 'fas fa-piggy-bank',
        
        // Table and data
        'mdi-table': 'fas fa-table',
        'mdi-database-off': 'fas fa-database',
        
        // Calendar and time
        'mdi-calendar': 'fas fa-calendar-alt',
        
        // Transaction history icons
        'mdi-file-document-outline': 'far fa-file-alt',
        'mdi-scale-balance': 'fas fa-balance-scale',
        'mdi-file-document-remove-outline': 'far fa-file-times',
        'mdi-chevron-double-left': 'fas fa-angle-double-left',
        'mdi-chevron-double-right': 'fas fa-angle-double-right',
        'mdi-calendar-blank': 'far fa-calendar',
        'mdi-delete-outline': 'far fa-trash-alt',
        'mdi-cash-remove': 'fas fa-money-bill-wave',
        
        // Additional icons found during migration
        'mdi-chart-line-variant': 'fas fa-chart-area',
        
        // Admin and Live component icons
        'mdi-calendar-month': 'fas fa-calendar-alt',
        'mdi-calendar-range': 'fas fa-calendar-week',
        'mdi-calendar-today': 'fas fa-calendar-day',
        'mdi-arrow-left': 'fas fa-arrow-left',
        'mdi-account-off': 'fas fa-user-slash',
        'mdi-calendar-remove': 'fas fa-calendar-minus',
        'mdi-sort': 'fas fa-sort',
        'mdi-sort-ascending': 'fas fa-sort-up',
        'mdi-sort-descending': 'fas fa-sort-down',
        'mdi-sync': 'fas fa-sync',
        'mdi-account-plus': 'fas fa-user-plus',
        'mdi-wallet-plus': 'fas fa-wallet',
        'mdi-calculator': 'fas fa-calculator',
        'mdi-weather-night': 'fas fa-moon',
        'mdi-white-balance-sunny': 'fas fa-sun',
        'mdi-moon-waning-crescent': 'fas fa-moon',
        
        // Adicionar mais mapeamentos conforme necessário
      };
      
      // Pega o mapeamento ou mantém MDI se não existir
      let baseClass = iconMap[this.name] || `mdi ${this.name}`;
      
      // Adiciona classes extras
      const classes = [baseClass];
      
      // Adiciona animação de loading
      if (this.spin || this.name === 'mdi-loading') {
        classes.push('fa-spin');
      }
      
      // Adiciona tamanho se especificado
      if (this.size) {
        classes.push(`fa-${this.size}`);
      }
      
      return classes.join(' ');
    },
    
    iconStyle() {
      const styles = {};
      if (this.color) {
        styles.color = this.color;
      }
      return styles;
    }
  }
}
</script>

<style scoped>
/* Garantir compatibilidade com animações */
.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
